import React from 'react';
import './scss/app.scss';
import Login from './pages/login';
import { observer } from 'mobx-react-lite';

const App = observer(function App() {
  return <Login />;
});
export default App;
